import React from "react";
import RemoteStart from "../images/remoteStart.mp4";
import PiRobot from "../images/3piRobot.mp4";
import { Button } from "@material-ui/core";
import "../styles/Projects.css";

function Projects() {
  return (
    <div className="projects">
      {/* <h1>Featured Websites</h1> */}
      {/* <div className="projects__projectOne"> */}
        {/* <div className="projects__info">
          <h3>Taqueria Las Cumbres</h3>
          <h5>Developed Using MERN (Mongo DB, Express, React, Node.js)</h5>
        </div> */}
        {/* <div className="projects__embed">
          <embed src="https://taquerialascumbres.com" />
        </div> */}
      {/* </div> */}

      {/* <div className="projects__projectOne">
        <div className="projects__info">
          <h3>The Patroons</h3>
          <h5>Developed Using MERN (Mongo DB, Express, React, Node.js)</h5>
        </div>
        <div className="projects__embed">
          <embed src="https://thepatroons.com" />
        </div>
      </div> */}

      <h1>Website Clones</h1>
      <div className="projects__clones">
        {/* <embed src="https://clone-em-f2927.web.app" /> */}
        <embed src="https://spotify-clone-5d6e7.web.app/" />
      </div>

      <div className="projects__clones">
        {/* <embed src="https://imessage-clone-7f537.web.app/" /> */}
        <embed src="https://hulu-clone-em.web.app" />
      </div>

      {/* <div className="projects__clones">
        <embed src="https://airbnb-clone-em.web.app" />
        <embed src="https://clone-em-db395.web.app/" />
      </div> */}

      {/* <div className="projects__clones">
        <embed src="https://instagram-clone-react-a9d8c.web.app" />
      </div> */}

      <h1>Featured Projects</h1>
      <div className="projects__featured">
        <div className="projects__infoTwo">
          <div className="projects__details">
            <h3>Remote Start</h3>
            <h5>Arduino</h5>
            <p>
              I engineered a remote start for my Chevrolet Suburban using an
              Arduino and a relay shield. I wired the starter, acc, and ignition
              wires to the relay so that the car may still be turned on with the
              key or the Arduino through serial communication via a bluetooth
              module.
            </p>
            <a href="https://github.com/edwin391/Projects/blob/master/remotestart.ino">
              <Button variant="outlined">Source Code</Button>
            </a>
          </div>
        </div>
        <div className="projects__vidTwo">
          <video controls loop>
            <source src={RemoteStart} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="projects__featuredThree">
        <div className="projects__infoThree">
          <div className="projects__detailsThree">
            <h3>3pi Robot</h3>
            <h5>3pi/C</h5>
            <p>
              I used the 3pi robot and its library to program the robot to find
              the shortest path in the maze. This is done by making the robot go
              through the whole maze once and then the program determines the
              shortest path.
            </p>
            <a href="https://github.com/edwin391/Projects/tree/master/3pi">
              <Button variant="outlined">Source Code</Button>
            </a>
          </div>
        </div>
        <div className="projects__vidThree">
          <video controls loop>
            <source src={PiRobot} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
}

export default Projects;
